import React, { useState } from 'react'

export default function PhotoInput({photoUrl, onFileLoad}) {
  const [dragging, setDragging] = useState(false)
  const imgUrl = photoUrl && photoUrl.includes('data:') ? photoUrl : photoUrl + '?' + Math.random()

  const fileLoaded = (files) => {
    if (files && files[0]) onFileLoad(files[0])
  }

  const handleDrag = function(e) {
    e.preventDefault()
    e.stopPropagation()
    if (e.type === 'dragenter' || e.type === 'dragover') return setDragging(true)
    if (e.type === 'dragleave') return setDragging(false)
  }

  const handleDrop = function(e) {
    e.preventDefault()
    e.stopPropagation()
    setDragging(false)
    fileLoaded(e.dataTransfer.files)
  }

  return <div className='team-photo-form'>
    <div className='team-photo-title'>Team logo</div>
    <div className='team-photo-content'>
      <div className='team-photo-drag-drop-area'>
        <input 
          type='file'
          accept='image/png,image/jpeg'
          id='team-photo-input'
          onChange={(e) => fileLoaded(e.target.files)}
        />
        <label 
          id='team-photo-label'
          className={dragging ? 'active' : '' }
          htmlFor='team-photo-input'
          onDragEnter={handleDrag}
          onDragOver={handleDrag}
          onDragLeave={handleDrag}
          onDrop={handleDrop}
        >
          <img src='/images/leagues/path.svg' />
          <span className='upload-button'>Upload a file</span>
          <span>PNG, JPG, up to 10MB</span>
          <span><b>or drag and drop</b></span>
        </label>
      </div>
      <div className='team-photo-preview'>
        { photoUrl &&
          <div className='photo-preview'>
            <img alt='Icon' src={imgUrl} />
          </div>
        }
      </div>
    </div>
  </div>
}
